import React, { useState, useEffect } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNodeUpdate } from '~/hooks/useNodeUpdate';
import { useSelector } from 'react-redux';
import { useNodeId } from '@xyflow/react';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { CustomHandle } from '~/utils/CustomHandle';
import { CustomAvatarSelect } from '~/utils/CustomAvatarSelect';

// Node de posicionamento de avatares
export const AvatarPosicionarNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();
    const avatars = useSelector((state) => state.avatars);
    const [selectedAvatar, setSelectedAvatar] = useState(data.selectedAvatar || "");
    const [x, setX] = useState(data.x || 0);
    const [y, setY] = useState(data.y || 0);

    // Atualiza os estados com os valores do data para o undo/redo
    useEffect(() => { setSelectedAvatar(data.selectedAvatar || ""); }, [data.selectedAvatar]);
    useEffect(() => { setX(data.x || 0); }, [data.x]);
    useEffect(() => { setY(data.y || 0); }, [data.y]);
    
    const [listaPendencias, setListaPendencias] = useState([]);
    const conferePendencias = () => {
        const pendencias = [];
        if (!selectedAvatar) pendencias.push("Avatar não selecionado");
        setListaPendencias(pendencias);
        return pendencias;
    };

    const handleAvatarChange = (value) => {
        setSelectedAvatar(value);
        onNodesChange([{ id, type: 'update', data: { selectedAvatar: value } }]);
    };

    const handleXChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        setX(value);
        onNodesChange([{ id, type: 'update', data: { x: value } }]);
    };

    const handleYChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        setY(value);
        onNodesChange([{ id, type: 'update', data: { y: value } }]);
    };

    useEffect(() => { conferePendencias(); }, [selectedAvatar]);

    // Opções de avatar para o select
    const avatarOptions = avatars
        .filter(avatar => avatar.nome) // Só avatares com nome
        .map((avatar, index) => ({
            value: index.toString(),
            label: avatar.nome
        }));

    return (
        <div className="node node-avatar-posicionar">
            <div className="titulo-node"><FontAwesomeIcon icon="fa-solid fa-up-down-left-right" />POSICIONAR AVATAR</div>
            <div className="linha-separadora" />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert("Executar")}><FontAwesomeIcon icon="fa-solid fa-circle-play" /></button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal">
                    <div className="body-node"></div>
                    
                    <div style={{ marginBottom: '12px' }}>
                        <span className="icon">Avatar:</span>
                        
                        {selectedAvatar && avatars[parseInt(selectedAvatar)] ? (
                            // Preview do avatar selecionado
                            <div style={{
                                marginTop: '8px',
                                padding: '12px',
                                border: '2px solid #e0e0e0',
                                borderRadius: '12px',
                                backgroundColor: '#f9f9f9',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#4CAF50';
                                e.currentTarget.style.backgroundColor = '#f1f8e9';
                                e.currentTarget.style.boxShadow = '0 4px 8px rgba(76, 175, 80, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#e0e0e0';
                                e.currentTarget.style.backgroundColor = '#f9f9f9';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                            }}
                            >
                                {/* Avatar circular */}
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: '#4CAF50',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                    {avatars[parseInt(selectedAvatar)].imagem ? (
                                        <img 
                                            src={avatars[parseInt(selectedAvatar)].imagem} 
                                            alt={avatars[parseInt(selectedAvatar)].nome}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                borderRadius: '50%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon="fa-solid fa-user" />
                                    )}
                                </div>
                                
                                {/* Nome do avatar */}
                                <div style={{ flex: 1 }}>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#333',
                                        marginBottom: '2px'
                                    }}>
                                        {avatars[parseInt(selectedAvatar)].nome}
                                    </div>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#666'
                                    }}>
                                        Avatar selecionado
                                    </div>
                                </div>
                                
                                {/* Botão remover */}
                                <button
                                    onClick={() => handleAvatarChange('')}
                                    style={{
                                        padding: '8px 16px',
                                        fontSize: '12px',
                                        backgroundColor: '#ff6b6b',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 4px rgba(255, 107, 107, 0.3)',
                                        transition: 'all 0.2s ease',
                                        minWidth: '80px',
                                        justifyContent: 'center'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#ff5252';
                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(255, 82, 82, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#ff6b6b';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(255, 107, 107, 0.3)';
                                    }}
                                    title="Remover avatar e selecionar outro"
                                >
                                    <FontAwesomeIcon icon="fa-solid fa-exchange-alt" />
                                    Trocar
                                </button>
                            </div>
                        ) : (
                            // Seletor quando nenhum avatar está selecionado
                            <div style={{ marginTop: '8px' }}>
                                <CustomAvatarSelect
                                    key={`avatar-select-${id}`}
                                    value={selectedAvatar}
                                    onChange={handleAvatarChange}
                                    options={avatarOptions}
                                    placeholder="Arraste um avatar aqui ou selecione abaixo"
                                />
                                {avatarOptions.length === 0 && (
                                    <div style={{
                                        marginTop: '8px',
                                        padding: '8px',
                                        backgroundColor: '#fff3cd',
                                        border: '1px solid #ffeaa7',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        color: '#856404'
                                    }}>
                                        ⚠️ Nenhum avatar disponível. Crie um avatar no painel lateral primeiro.
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                        <div style={{ flex: 1 }}>
                            <span className="icon">X:</span>
                            <input
                                type="number"
                                value={x}
                                onChange={handleXChange}
                                style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }}
                                placeholder="Posição X"
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <span className="icon">Y:</span>
                            <input
                                type="number"
                                value={y}
                                onChange={handleYChange}
                                style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }}
                                placeholder="Posição Y"
                            />
                        </div>
                    </div>

                    {selectedAvatar && avatars[parseInt(selectedAvatar)] && (
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#666', 
                            marginTop: '8px',
                            padding: '8px',
                            background: '#f5f5f5',
                            borderRadius: '4px'
                        }}>
                            <strong>Prévia:</strong> Mover avatar &quot;{avatars[parseInt(selectedAvatar)].nome}&quot; para ({x}, {y})
                        </div>
                    )}

                    <CustomHandle type="target" position="top" connectionCount={1} />
                    <CustomHandle type="source" position="bottom" connectionCount={1} />
                </div>
            </div>
        </div>
    );
};
